module.exports = __webpack_public_path__ + "img/samsung_banner.161110d.png";